import React from "react";
import Form from "react-bootstrap/lib/Form";

export const Checkbox = ({
  isActive,
  values,
  setFieldValue,
  errors,
  fieldName,
  fieldId,
  isRequired,
}) => (
  <Form.Group style={{ marginTop: "25px" }}>
    <label className="checkbox">
      <input
        className="checkbox__input"
        type="checkbox"
        disabled={!isActive}
        id={fieldId}
        name={fieldId}
        value={values[fieldId]}
        checked={values[fieldId]}
        placeholder={fieldName}
        onChange={(e) => setFieldValue(fieldId, e.target.checked)}
      />
      <span className="row row--align-center row--nowrap">
        <span className="checkbox__button checkbox__button-left margin-right-5">
          <span className="checkbox__button-checkbox" />
        </span>
        <span className="text">{isRequired ? `${fieldName}*` : fieldName}</span>
      </span>
    </label>
    <Form.Control.Feedback type="invalid" className="field--invalid d-flex">
      {errors[fieldId]}
    </Form.Control.Feedback>
  </Form.Group>
);
